import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { isEmpty, find, propOr, ifElse, test, includes, equals, prop, pipe, is, reject, isNil, mergeRight, has, toString, always, assoc, not } from 'ramda';

var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var urlSchemeRegex = /^([^:]+):/gm;
var relativeFirstCharacters = [".", "/"];
var stringsToRemove = ['<script>', '</script>', '</', 'alert(', '<', '>'];
function removeAlert() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var decodedUrl = decodeURIComponent(url);
  stringsToRemove.forEach(function (item) {
    var itemRemoved = decodedUrl.split(item);
    decodedUrl = itemRemoved.join('');
  });
  return decodedUrl;
}
function isRelativeUrlWithoutProtocol() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return relativeFirstCharacters.indexOf(url[0]) > -1;
}
var sanitizeUrl = function sanitizeUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!url) {
    return "about:blank";
  }
  var sanitizedUrl = url.replace(ctrlCharactersRegex, "").trim();
  if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
    return removeAlert(sanitizedUrl);
  }
  var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
  if (!urlSchemeParseResults) {
    return removeAlert(sanitizedUrl);
  }
  var urlScheme = urlSchemeParseResults[0];
  if (invalidProtocolRegex.test(urlScheme)) {
    return "about:blank";
  }
  return removeAlert(sanitizedUrl);
};

var isSuccessResponse = function isSuccessResponse(code) {
  return code >= 200 && code < 300;
};
var supportEmptyResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var clonedResponse, contentText;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return response.clone();
        case 2:
          clonedResponse = _context.sent;
          _context.next = 5;
          return clonedResponse.text();
        case 5:
          contentText = _context.sent;
          return _context.abrupt("return", isEmpty(contentText) ? contentText : response.json());
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function supportEmptyResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();

var MiEspacioSKMappings = [{
  apiRegex: /\/ux\/web-apvsf/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_KNOWMADAS
}, {
  apiRegex: /\/ux\/web-digital-procedure/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_DMENTES
}, {
  apiRegex: /\/ux\/ms-ux-tr-mepa-firmadigital/,
  skEnv: process.env.REACT_APP_MEPA_SK_DMENTES_BIOMETRIC_AND_SIGNATURE
}, {
  apiRegex: /\/ux\/api-ux-pm-validarequisitos/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_MINIMUM_PENSION
}, {
  apiRegex: /\/ux\/api-ux-pm-gestiontramite/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_MINIMUM_PENSION
}, {
  apiRegex: /\/ux\/api-ux-pm-mepa-gestionpensionminima/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_MINIMUM_PENSION_MANAGE
}, {
  apiRegex: /\/ux\/migration-transactional-web/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_QAMALEON
}, {
  apiRegex: /\/ux\/web-95\.5/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_VIRTUAL
}, {
  apiRegex: /\/ux\/api-ux-tv-mepa-generaconstancia/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_QAMALEON_WEB_GENERA_CONSTANCIA
}, {
  apiRegex: /\/ux\/api-ux-955-mepa-exoneracion45/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_KNOWMADAS_WEB_EXONERACION_45
}, {
  apiRegex: /\/ux\/api-ux-tv-mepa-solicitacambiofondo/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_QAMALEON_WEB_FUND_TYPE_CHOOSE
}, {
  apiRegex: /\/ux\/api-ux-sa-mepa-gestiondatosafiliado/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_QAMALEON_GESTION_DATOS_AFILIADO
}, {
  apiRegex: /\/ux\/api-ux-sa-av955-gestion955/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_KNOWMADAS_WEB_CHANGE_OF_FUND
}, {
  apiRegex: /\/ux\/api-ux-sa-avpr-gestiontramitesautomaticos/,
  skEnv: process.env.REACT_APP_MEPA_API_SK_WEB_GESTION_TRAMITES_AUTOMATICOS
}];
var PlataformaBackSKMappings = [{
  apiRegex: /\/ux\/pac-apvsf/,
  skEnv: process.env.REACT_APP_PAC_API_SK_KNOWMADAS
}, {
  apiRegex: /\/ux\/pac-digital-procedure/,
  skEnv: process.env.REACT_APP_PAC_API_SK_DMENTES
}, {
  apiRegex: /\/ux\/pac-95\.5/,
  skEnv: process.env.REACT_APP_PAC_API_SK_VIRTUAL
}, {
  apiRegex: /\/ux\/api-ux-955-npac-consultatramite/,
  skEnv: process.env.REACT_APP_PAC_API_SK_KNOWMADAS_WEB_CONSULTA_TRAMITE
}, {
  apiRegex: /\/ux\/ms-ux-tr-npac-firmadigital/,
  skEnv: process.env.REACT_APP_API_URL_NPAC_SK_DMENTES_BIOMETRIC_AND_SIGNATURE
}];
var EstadoDeAhorrosSKMappings = [{
  apiRegex: /\/ux\/eeaa/,
  skEnv: process.env.REACT_APP_EEAA_API_SK
}];
var EstimadorPensionMinimaSKMappings = [{
  apiRegex: /\/ux\/api-ux-pm-calculoexcedente/,
  skEnv: process.env.REACT_APP_PME_API_SK
}];
var TraspasosSKMappings = [{
  apiRegex: /\/ux\/transfer-digital-services-web/,
  skEnv: process.env.REACT_APP_TRANSFERS_API_SK
}];
var TraspasosTOCSKMappings = [{
  apiRegex: /\/api-ux-tpdg-validacionfacial\/validacion-facial/,
  skEnv: process.env.REACT_APP_TRANSFERS_API_SK
}];
var TraspasosTOCValidacionSKMappings = [{
  apiRegex: /\/api-ux-tpdg-validacionprospecto/,
  skEnv: process.env.REACT_APP_TRANSFERS_API_SK_TOC
}];
var TraspasosTOCAfiliacionSKMappings = [{
  apiRegex: /\/api-ux-tpdg-traspasoafiliado/,
  skEnv: process.env.REACT_APP_TRANSFERS_API_SK_TOC
}];

// Data Update Web & Informative Zone (Libro de Reclamaciones)
var MigrationServicesApiSKMappings = [{
  apiRegex: /\/ux\/migration-services-web/,
  skEnv: process.env.REACT_APP_MIGRATION_SERVICES_WEB_API_SK
}];
var CommonSKMappings = [{
  apiRegex: /\/ux\/oauth-manager-spa/,
  skEnv: process.env.REACT_APP_OAUTH_MANAGER_SPA_API_SK
}];
var InversionesPersonalesSKMappings = [{
  apiRegex: /\/ux\/api-ux-si-saip-gestionmantenimiento/,
  skEnv: process.env.VITE_APP_SAIP_API_SK_GESTION_MANTENIMIENTO
}, {
  apiRegex: /\/ux\/api-ux-si-saip-gestioninversion/,
  skEnv: process.env.VITE_APP_SAIP_API_SK_GESTION_INVERSION
}];
var apiSKMappings = [].concat(MiEspacioSKMappings, PlataformaBackSKMappings, EstadoDeAhorrosSKMappings, EstimadorPensionMinimaSKMappings, TraspasosSKMappings, TraspasosTOCSKMappings, TraspasosTOCValidacionSKMappings, TraspasosTOCAfiliacionSKMappings, MigrationServicesApiSKMappings, CommonSKMappings, InversionesPersonalesSKMappings);
var getSKForBaseUrlAPI = function getSKForBaseUrlAPI() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var mapping = find(function (mapping) {
    return api.match(mapping.apiRegex);
  }, apiSKMappings);
  var skEnv = mapping ? mapping.skEnv : null;
  return skEnv || 'SK_NOT_FOUND';
};

var defaultHeaders = {
  'Content-Type': 'application/json'
};
var defaultMethod = 'GET';

/**
 * Service Fetcher Factory
 * @param {string} options - options to create a Service Fetcher.
 * @param {string} options - options.tokenPathUrl - Path to get token.
 * @param {string} options - options.loginPathUrl - Path of login service.
 * @param {string} options - options.baseUrl - Base request url.
 * @param {string} options - options.refreshTokenGetter - Function to get the access token.
 * @param {string} options - options.accessTokenGetter - Function to get the refresh token.
 * @param {string} options - options.onLogout - Callback for logout.
 * @param {string} options - options.onRefresh - Callback for refresh token.
 */

function serviceFetcherCreate(options) {
  var activeDirectoryAuth = propOr(false, 'activeDirectoryAuth', options);
  var BASE_URL = propOr('', 'baseUrl', options);
  var accessTokenGetter = propOr('', 'accessTokenGetter', options);
  var onLogout = propOr('', 'onLogout', options);
  var onError = propOr('', 'onError', options);
  // refresh data
  var REFRESH_TOKEN_PATH = !activeDirectoryAuth ? propOr('', 'tokenPathUrl', options) : '';
  var refreshTokenGetter = !activeDirectoryAuth ? propOr('', 'refreshTokenGetter', options) : '';
  var onRefresh = !activeDirectoryAuth ? propOr('', 'onRefresh', options) : '';
  var requestUrl = ifElse(test(/(https?:\/\/)/g), function (value) {
    return value;
  }, function (value) {
    return "".concat(BASE_URL).concat(value);
  });
  var refreshFetch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var refreshResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _serviceFetcher(REFRESH_TOKEN_PATH, {
              method: 'POST',
              body: {
                refreshToken: refreshTokenGetter()
              },
              authenticated: false
            });
          case 2:
            refreshResponse = _context.sent;
            onRefresh(refreshResponse);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function refreshFetch() {
      return _ref.apply(this, arguments);
    };
  }();
  var addAuthHeader = function addAuthHeader(headers) {
    return assoc('Authorization', "Bearer ".concat(accessTokenGetter()), headers);
  };
  var addSubscriptionKeyHeader = function addSubscriptionKeyHeader(headers, urlForFetch) {
    return assoc('ocp-apim-subscription-key', getSKForBaseUrlAPI(urlForFetch), headers);
  };
  var addSecurityHeaders = function addSecurityHeaders(headers, authenticated, urlForFetch) {
    return ifElse(function () {
      return authenticated;
    }, pipe(addAuthHeader, function (headers) {
      return addSubscriptionKeyHeader(headers, urlForFetch);
    }), function (value) {
      return value;
    })(headers);
  };
  var generateNormalOptions = function generateNormalOptions(authenticated, urlForFetch) {
    return function (requestOptions) {
      return reject(isNil, {
        method: propOr(defaultMethod, 'method', requestOptions),
        headers: mergeRight(addSecurityHeaders(defaultHeaders, authenticated, urlForFetch), prop('headers', requestOptions)),
        body: ifElse(has('body'), pipe(prop('body'), toString), always(null))(requestOptions)
      });
    };
  };
  var generateFormDataOptions = function generateFormDataOptions(authenticated, urlForFetch) {
    return function (requestOptions) {
      return reject(isNil, {
        method: propOr(defaultMethod, 'method', requestOptions),
        headers: mergeRight(addSecurityHeaders({}, authenticated, urlForFetch), prop('headers', requestOptions)),
        body: prop('body', requestOptions)
      });
    };
  };
  var parseError = function parseError(errorResponse, res) {
    var error = new Error();
    error.message = ifElse(has('errorMessage'), prop('errorMessage'), prop('message'))(errorResponse);
    error.status = res.status;
    error.data = errorResponse;
    return error;
  };
  var responseTypeParser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response, optionType) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = optionType;
            _context2.next = _context2.t0 === 'blob' ? 3 : _context2.t0 === 'text' ? 4 : _context2.t0 === 'raw' ? 5 : 6;
            break;
          case 3:
            return _context2.abrupt("return", response.blob());
          case 4:
            return _context2.abrupt("return", response.text());
          case 5:
            return _context2.abrupt("return", response);
          case 6:
            return _context2.abrupt("return", supportEmptyResponse(response));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function responseTypeParser(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Service Fetcher
   * @param {string} url - Request url.
   * @param {object} requestOptions - Request options.
   * @param {boolean} requestOptions.authenticated - To enable authentication.
   * @param {boolean} requestOptions.avoidRefresh - To avoid the refresh token process.
   * @param {boolean} requestOptions.featuredResponse - To get extra response.
   * @param {string} requestOptions.method - Request method.
   * @param {object} requestOptions.body - Request body.
   */
  var _serviceFetcher = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, requestOptions) {
      var authenticated, featuredResponse, responseType, avoidRefresh, forceNoApiCall, urlForFetch, _options, res, responseClone, responseStatus, errorResponse, error, parsedResponse;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            authenticated = propOr(true, 'authenticated', requestOptions);
            featuredResponse = propOr(false, 'featuredResponse', requestOptions);
            responseType = propOr('json', 'responseType', requestOptions);
            avoidRefresh = propOr(false, 'avoidRefresh', requestOptions);
            forceNoApiCall = propOr(false, 'forceNoApiCall', requestOptions);
            if (!forceNoApiCall) {
              _context3.next = 7;
              break;
            }
            return _context3.abrupt("return");
          case 7:
            urlForFetch = requestUrl(sanitizeUrl(url));
            _options = ifElse(pipe(prop('body'), is(FormData)), generateFormDataOptions(authenticated, urlForFetch), generateNormalOptions(authenticated, urlForFetch))(requestOptions);
            _context3.next = 11;
            return fetch(urlForFetch, _options);
          case 11:
            res = _context3.sent;
            responseClone = res.clone();
            responseStatus = res.status;
            if (isSuccessResponse(responseStatus)) {
              _context3.next = 35;
              break;
            }
            if (!activeDirectoryAuth && includes(REFRESH_TOKEN_PATH, url)) {
              onLogout();
            }
            if (!(!activeDirectoryAuth && equals(prop('status', res), 401) && authenticated && !avoidRefresh)) {
              _context3.next = 29;
              break;
            }
            _context3.prev = 17;
            _context3.next = 20;
            return refreshFetch();
          case 20:
            return _context3.abrupt("return", _serviceFetcher(url, requestOptions));
          case 23:
            _context3.prev = 23;
            _context3.t0 = _context3["catch"](17);
            console.error('logout', _context3.t0);
            onLogout();
          case 27:
            _context3.next = 35;
            break;
          case 29:
            _context3.next = 31;
            return res.json();
          case 31:
            errorResponse = _context3.sent;
            error = parseError(errorResponse, res);
            onError(error, {
              options: _options,
              endpoint: url,
              status: responseStatus
            });
            throw error;
          case 35:
            _context3.next = 37;
            return responseTypeParser(responseClone, responseType);
          case 37:
            parsedResponse = _context3.sent;
            if (!featuredResponse) {
              _context3.next = 40;
              break;
            }
            return _context3.abrupt("return", {
              status: responseStatus,
              data: parsedResponse
            });
          case 40:
            return _context3.abrupt("return", parsedResponse);
          case 41:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[17, 23]]);
    }));
    return function serviceFetcher(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return _serviceFetcher;
}

/**
 * Service Fetcher Factory
 * @param {string} options - options to create a Service Fetcher.
 * @param {string} options - options.baseUrl - Base request url.
 * @param {string} options - options.tokenUrl - Token url.
 * @param {string} options - options.tokenRequestOptions - Token request options.
 * @param {string} options - options.accessTokenGetter - Access token getter.
 * @param {string} options - options.onError - Callback for error.
 * @param {string} options - options.onGetToken - Callback for get token.
 */

function serviceFetcherCreatePublic(options) {
  var BASE_URL = propOr('', 'baseUrl', options);
  var TOKEN_URL = propOr('', 'tokenUrl', options);
  var tokenRequestOptions = propOr({}, 'tokenRequestOptions', options);
  var accessTokenGetter = propOr(function () {}, 'accessTokenGetter', options);
  var onError = propOr(function () {}, 'onError', options);
  var onGetToken = propOr(function () {}, 'onGetToken', options);
  var requestUrl = ifElse(test(/(https?:\/\/)/g), function (value) {
    return value;
  }, function (value) {
    return "".concat(BASE_URL).concat(value);
  });
  var getTokenFetch = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var tokenResponse;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _serviceFetcher(TOKEN_URL, assoc('isTokenFetch', true, tokenRequestOptions));
          case 2:
            tokenResponse = _context.sent;
            onGetToken(tokenResponse);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getTokenFetch() {
      return _ref.apply(this, arguments);
    };
  }();
  var addAuthHeader = function addAuthHeader(headers) {
    return assoc('Authorization', "Bearer ".concat(accessTokenGetter()), headers);
  };
  var addSubscriptionKeyHeader = function addSubscriptionKeyHeader(headers, urlForFetch) {
    return assoc('ocp-apim-subscription-key', getSKForBaseUrlAPI(urlForFetch), headers);
  };
  var addSecurityHeaders = function addSecurityHeaders(headers, authenticated, urlForFetch) {
    return ifElse(function () {
      return authenticated;
    }, pipe(addAuthHeader, function (headers) {
      return addSubscriptionKeyHeader(headers, urlForFetch);
    }), function (value) {
      return value;
    })(headers);
  };
  var generateNormalOptions = function generateNormalOptions(authenticated, urlForFetch) {
    return function (requestOptions) {
      return reject(isNil, {
        method: propOr(defaultMethod, 'method', requestOptions),
        headers: mergeRight(addSecurityHeaders(defaultHeaders, authenticated, urlForFetch), prop('headers', requestOptions)),
        body: ifElse(has('body'), pipe(prop('body'), toString), always(null))(requestOptions)
      });
    };
  };
  var generateFormDataOptions = function generateFormDataOptions(authenticated, urlForFetch) {
    return function (requestOptions) {
      return reject(isNil, {
        method: propOr(defaultMethod, 'method', requestOptions),
        headers: mergeRight(addSecurityHeaders({}, authenticated, urlForFetch), prop('headers', requestOptions)),
        body: prop('body', requestOptions)
      });
    };
  };
  var parseError = function parseError(errorResponse, res) {
    var error = new Error();
    error.message = ifElse(has('errorMessage'), prop('errorMessage'), prop('message'))(errorResponse);
    error.status = res.status;
    error.url = res.url;
    error.data = errorResponse;
    return error;
  };
  var responseTypeParser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response, optionType) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.t0 = optionType;
            _context2.next = _context2.t0 === 'blob' ? 3 : _context2.t0 === 'text' ? 4 : _context2.t0 === 'raw' ? 5 : 6;
            break;
          case 3:
            return _context2.abrupt("return", response.blob());
          case 4:
            return _context2.abrupt("return", response.text());
          case 5:
            return _context2.abrupt("return", response);
          case 6:
            return _context2.abrupt("return", supportEmptyResponse(response));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function responseTypeParser(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * Service Fetcher
   * @param {string} url - Request url.
   * @param {object} requestOptions - Request options.
   * @param {string} requestOptions.method - Request method.
   * @param {object} requestOptions.body - Request body.
   * @param {boolean} requestOptions.featuredResponse - To get extra response.
   * @param {string} requestOptions.responseType - Response type.
   * @param {boolean} requestOptions.avoidGetToken - To avoid the get token process.
   */
  var _serviceFetcher = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, requestOptions) {
      var authenticated, featuredResponse, responseType, isTokenFetch, urlForFetch, _options, res, responseClone, errorResponse, error, parsedResponse;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            authenticated = propOr(true, 'authenticated', requestOptions);
            featuredResponse = propOr(false, 'featuredResponse', requestOptions);
            responseType = propOr('json', 'responseType', requestOptions);
            isTokenFetch = propOr(false, 'isTokenFetch', requestOptions);
            urlForFetch = requestUrl(sanitizeUrl(url));
            _options = ifElse(pipe(prop('body'), is(FormData)), generateFormDataOptions(authenticated, urlForFetch), generateNormalOptions(authenticated, urlForFetch))(requestOptions);
            _context3.next = 8;
            return fetch(urlForFetch, _options);
          case 8:
            res = _context3.sent;
            responseClone = res.clone();
            if (!not(isSuccessResponse(res.status))) {
              _context3.next = 32;
              break;
            }
            if (!isTokenFetch) {
              _context3.next = 13;
              break;
            }
            return _context3.abrupt("return", onError("Error getting token - Status: ".concat(res.status)));
          case 13:
            if (!equals(res.status, 401)) {
              _context3.next = 26;
              break;
            }
            _context3.prev = 15;
            _context3.next = 18;
            return getTokenFetch();
          case 18:
            return _context3.abrupt("return", _serviceFetcher(url, requestOptions));
          case 21:
            _context3.prev = 21;
            _context3.t0 = _context3["catch"](15);
            return _context3.abrupt("return", onError("Error getting token - Status: ".concat(res.status)));
          case 24:
            _context3.next = 32;
            break;
          case 26:
            _context3.next = 28;
            return res.json();
          case 28:
            errorResponse = _context3.sent;
            error = parseError(errorResponse, res);
            onError("Error fetching data - Message: ".concat(error.message, " - Status: ").concat(error.status, " - Url: ").concat(error.url));
            throw error;
          case 32:
            _context3.next = 34;
            return responseTypeParser(responseClone, responseType);
          case 34:
            parsedResponse = _context3.sent;
            if (!featuredResponse) {
              _context3.next = 37;
              break;
            }
            return _context3.abrupt("return", {
              status: res.status,
              data: parsedResponse
            });
          case 37:
            return _context3.abrupt("return", parsedResponse);
          case 38:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[15, 21]]);
    }));
    return function serviceFetcher(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  return _serviceFetcher;
}

export { serviceFetcherCreatePublic as a, serviceFetcherCreate as s };
